import { FC, useMemo } from 'react'
import styles from 'components/features/rewards/rewardPageCryptoWallet/RewardsPageCryptoWallet/RewardsPageCryptoWallet.styl'
import { cryptoMetaGuard } from 'components/features/rewards/rewardsPane/guards/cryptoMetaGuard'
import { useSimpleGuard } from 'helpers/loadableHelpers'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { cryptoWalletNotEmptyTickerSelector } from 'components/features/rewards/rewardsPane/store/selectors/cryptoWallet'
import { WalletItem } from 'components/features/rewards/rewardPageCryptoWallet/WalletItem/WalletItem'
import ModuleWrapper2020 from 'components/features/pfm/ModuleWrapper2020/ModuleWrapper2020'
import { rewardsSummaryGuard } from 'components/features/rewards/rewardsPane/guards/rewardsSummaryGuard'

type RewardsPageCryptoWalletProps = {
  className: string
}

export const RewardsPageCryptoWallet: FC<RewardsPageCryptoWalletProps> = (props) => {
  const { className } = props

  useSimpleGuard(rewardsSummaryGuard, {}, 'RewardsPageCryptoWallet')
  useSimpleGuard(cryptoMetaGuard, {}, 'RewardsPageCryptoWallet')

  const cryptoWalletTickers = useStoreSelector(cryptoWalletNotEmptyTickerSelector)

  const itemsChild = useMemo(() => {
    if (!cryptoWalletTickers?.length) {
      return null
    }

    return cryptoWalletTickers.map((ticker) => (
      <div
        key={ ticker }
        className={ styles.item }
      >
        <WalletItem ticker={ ticker } />
      </div>
    ))
  }, [cryptoWalletTickers])

  if (!itemsChild) {
    return null
  }

  return (
    <ModuleWrapper2020
      title='Portfolio'
      className={ className }

      corners='all'
      forceRoundedCorners
      shadowTheme='regular'
      noPadding
    >
      { itemsChild }
    </ModuleWrapper2020>
  )
}
